// extracted by mini-css-extract-plugin
export default {"tableContainer":"SWP_PDFCalculator_tableContainer__SC+DR","th":"SWP_PDFCalculator_th__kZLWD","td":"SWP_PDFCalculator_td__-6k3e"};